import { createSelector } from 'redux-orm';
import orm from '%paysera_seat_selection/js/seatSelection/redux/model';
import { resolveObjectByCoordinates } from '%paysera_seat_selection/js/seatSelection/redux/component/orm/services/resolveObjectByCoordinates';
import { getSelectableObjects } from '%paysera_seat_selection/js/seatSelection/redux/component/orm/services/getSelectableObjects';
import dbSelector from './dbSelector';

const selectObjectByCoordinates = createSelector(
    orm,
    dbSelector,
    (state, coordinates, selection) => ({ coordinates, selection }),
    (session, { coordinates, selection }) => {
        if (coordinates === null || selection === null) {
            return {
                object: null,
            };
        }

        return resolveObjectByCoordinates(getSelectableObjects(session, selection), coordinates);
    },
);

export default selectObjectByCoordinates;
